import { REQUIRED_CLASS_NAME } from "./const";
import { RequiredLabelProps } from "./type";

export const RequiredLabel = ({ rectangle }: RequiredLabelProps) => (
  <span className={REQUIRED_CLASS_NAME({ rectangle: !!rectangle })}>必須</span>
);
